import Bridge from '@/utils/bridge.js'
import axios from 'axios'
import store from '@/store'
import dayjs from 'dayjs'
import { Toast } from 'vant'
// 根据环境不同引入不同api地址
import { baseApi } from '@/config'
// create an axios instance
const service = axios.create({
  // 自定义配置
  baseURL: baseApi, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10 * 1000 // request timeout 10秒 超时
})
// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// request拦截器 request interceptor
service.interceptors.request.use(
  (config) => {
    // 不传递默认开启loading
    if (!config.hideloading) {
      // loading
      Toast.loading({
        forbidClick: true
      })
    }
    const tokentime = store.state.app.tokentime
    const localtime = dayjs()
    let token = store.state.app.token
    console.log('diff=' + localtime.diff(tokentime, 'minute'))
    if (localtime.diff(tokentime, 'minute') > 50) {
      Bridge.callHandler('dataToNative', { 'type': 2 }, (responseData) => {
        store.commit('app/set_token', responseData.token)
        store.commit('app/set_tokentime', dayjs())
        token = responseData.token
      })
    }

    if (token) config.headers['Authorization'] = `Bearer ${token}`

    config.headers['sn-common'] = `version=v1&app=20240703&channel=h5`

    // get参数编码
    if (config.method === 'get' && config.params) {
      let url = config.url
      if (url.indexOf('?') === -1) {
        url += '?'
      } else {
        url += '&'
      }
      const keys = Object.keys(config.params)
      for (const key of keys) {
        if (config.params[key] !== undefined && config.params[key] !== '') {
          url += `${encodeURIComponent(key)}=${config.params[key]}&`
        }
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response拦截器
service.interceptors.response.use(
  (response) => {
    Toast.clear()
    // store.commit('app/set_time', response['current-time'])
    return response.data.data
  },
  (error) => {
    // Toast.clear()

    if (error.response) {
      // http 报错的响应码均为500
      switch (error.response.data.code) {
        case -22:
          // Token已经过期
          Toast('网络出错，请稍候重试')
          Bridge.callHandler('dataToNative', { 'type': 2 }, (responseData) => {
            store.commit('app/set_token', responseData.token)
          })
          break
        case -101:
          // 手机号验证码不符
          Toast('手机号验证码不符')
          break
        case -1020:
          // 账号已存在
          return error.response.data
        case -11011:
          // 工猫需绑定手机号，
          return error.response.data
        default:
          Toast(error.response.data.detail_message || error.response.data.error_message)
          return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/http/request.js